<template>
  <div class="col responsive-width">
    <div class="container-fluid">
      <div class="content">
        <div class="d-flex align-items-center flex-wrap justify-content-between">
          <div>
            <h1 class="mb-0">{{ $services.helpers.capitalizeNames($t('alerts')) }}</h1>
            <span>Archieve ({{ archived.length }})</span>
          </div>
          <router-link :to="{ name : 'alertinbox'}" class="my-2 my-sm-0">
            <svg class="me-2" width="7" height="14" viewbox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M5.83749 14.0003C5.68809 14.0008 5.54048 13.9678 5.4055 13.9038C5.27052 13.8398 5.15161 13.7463 5.05749 13.6303L0.227488 7.63028C0.0804062 7.45134 0 7.2269 0 6.99528C0 6.76365 0.0804062 6.53921 0.227488 6.36028L5.22749 0.360276C5.39723 0.156059 5.64114 0.0276347 5.90556 0.00325494C6.16999 -0.0211248 6.43327 0.0605371 6.63749 0.230276C6.8417 0.400014 6.97013 0.643926 6.99451 0.908352C7.01889 1.17278 6.93723 1.43606 6.76749 1.64028L2.29749 7.00028L6.61749 12.3603C6.73977 12.5071 6.81745 12.6858 6.84133 12.8753C6.86521 13.0649 6.83429 13.2573 6.75223 13.4299C6.67018 13.6024 6.54042 13.7478 6.37831 13.8489C6.2162 13.95 6.02852 14.0025 5.83749 14.0003Z"
                  fill="#5855D6"></path>
            </svg>
            {{ $t('go_back_inbox') }}
          </router-link>
        </div>
        <div class="box-responsive">
          <div class="box">
            <table>
              <thead>
              <tr>
                <th>{{ $services.helpers.capitalizeNames($t('subject')) }}</th>
                <th style="width:60%">{{ $services.helpers.capitalizeNames($t('alert')) }}</th>
                <th>{{ $services.helpers.capitalizeNames($t('received')) }}</th>
                <th>{{ $services.helpers.capitalizeNames($t('archive')) }}</th>

                <th></th>
              </tr>
              </thead>
              <tbody v-if="archived.length > 0">
              <tr v-for="item in archived" :key="item.id">
                <td>{{ item.alert_code.code }}</td>
                <td>
                  <p>{{ item.message }}</p>
                </td>
                <td>{{ item.received.split('T')[0] }}</td>
                <td>{{ item.received.split('T')[0] }}</td>
                <td>
                  <router-link :to="{ name : 'alertmessage', params : { id : item.id } }">See full message</router-link>
                  <div class="icons">
                    <svg @click="openAlertMessage(item)" width="22" height="21" viewbox="0 0 22 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M17.7221 18.6663H4.27764V12.833H3.05542V18.6663C3.05542 18.9758 3.18419 19.2725 3.4134 19.4913C3.64261 19.7101 3.95349 19.833 4.27764 19.833H17.7221C18.0462 19.833 18.3571 19.7101 18.5863 19.4913C18.8155 19.2725 18.9443 18.9758 18.9443 18.6663V12.833H17.7221V18.6663Z"
                          fill="black"></path>
                      <path
                          d="M8.55542 14.0003C8.55542 14.155 8.6198 14.3034 8.73441 14.4128C8.84902 14.5222 9.00445 14.5837 9.16653 14.5837H12.8332C12.9953 14.5837 13.1507 14.5222 13.2653 14.4128C13.3799 14.3034 13.4443 14.155 13.4443 14.0003C13.4443 13.8456 13.3799 13.6972 13.2653 13.5878C13.1507 13.4784 12.9953 13.417 12.8332 13.417H9.16653C9.00445 13.417 8.84902 13.4784 8.73441 13.5878C8.6198 13.6972 8.55542 13.8456 8.55542 14.0003Z"
                          fill="black"></path>
                      <path
                          d="M9.1668 10.5H3.6668V8.16667H9.1668V7H3.36125C3.11813 7 2.88497 7.09219 2.71307 7.25628C2.54116 7.42038 2.44458 7.64294 2.44458 7.875V11.6667H9.64347C9.33926 11.3472 9.1695 10.9317 9.1668 10.5Z"
                          fill="black"></path>
                      <path
                          d="M18.6389 7H12.8334V8.16667H18.3334V10.5H12.8334C12.8307 10.9317 12.6609 11.3472 12.3567 11.6667H19.5556V7.875C19.5556 7.64294 19.459 7.42038 19.2871 7.25628C19.1152 7.09219 18.882 7 18.6389 7Z"
                          fill="black"></path>
                      <path
                          d="M7.94453 5.57059L10.389 3.26642V10.4998C10.389 10.6545 10.4534 10.8028 10.568 10.9122C10.6826 11.0216 10.838 11.0831 11.0001 11.0831C11.1622 11.0831 11.3176 11.0216 11.4322 10.9122C11.5468 10.8028 11.6112 10.6545 11.6112 10.4998V3.26642L14.0556 5.57059C14.1126 5.62459 14.1802 5.66736 14.2545 5.69644C14.3288 5.72552 14.4083 5.74035 14.4886 5.74008C14.5689 5.73981 14.6484 5.72444 14.7225 5.69486C14.7965 5.66528 14.8638 5.62206 14.9204 5.56767C14.9769 5.51328 15.0217 5.44879 15.0522 5.37787C15.0827 5.30695 15.0982 5.231 15.0979 5.15436C15.0976 5.07771 15.0815 5.00187 15.0506 4.93116C15.0196 4.86045 14.9743 4.79626 14.9173 4.74225L11.0001 1.03809L7.09509 4.74225C7.00045 4.85343 6.95198 4.99395 6.9589 5.13705C6.96583 5.28014 7.02768 5.4158 7.13265 5.51817C7.23763 5.62054 7.3784 5.68246 7.52813 5.69212C7.67785 5.70179 7.82607 5.65853 7.94453 5.57059Z"
                          fill="black"></path>
                    </svg>
                    <svg @click="openDeletedMessageModal(item)" width="20" height="21" viewbox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M9.75012 6.97518e-09C10.6251 -5.43467e-05 11.467 0.317554 12.103 0.887672C12.7391 1.45779 13.121 2.23719 13.1706 3.066L13.1758 3.25H18.7097C18.91 3.25006 19.1028 3.32224 19.2492 3.45197C19.3955 3.5817 19.4845 3.7593 19.4982 3.94888C19.5118 4.13846 19.4491 4.32589 19.3227 4.4733C19.1963 4.62071 19.0156 4.7171 18.8172 4.743L18.7097 4.75H17.8707L16.5214 17.77C16.4538 18.4191 16.1453 19.0243 15.6508 19.4775C15.1563 19.9306 14.5081 20.2023 13.822 20.244L13.6365 20.25H5.86378C5.17596 20.25 4.51056 20.0179 3.98649 19.5953C3.46242 19.1727 3.11384 18.587 3.00304 17.943L2.97879 17.769L1.62853 4.75H0.79055C0.599514 4.74999 0.414942 4.68436 0.270968 4.56523C0.126995 4.44611 0.0333594 4.28155 0.00737844 4.102L0 4C8.05613e-06 3.81876 0.0691917 3.64366 0.194757 3.50707C0.320322 3.37048 0.493774 3.28165 0.683035 3.257L0.79055 3.25H6.3244C6.3244 2.38805 6.68533 1.5614 7.32777 0.951903C7.97022 0.34241 8.84156 6.97518e-09 9.75012 6.97518e-09ZM16.2822 4.75H3.21701L4.55252 17.622C4.58209 17.9092 4.7155 18.1779 4.93011 18.3824C5.14472 18.5869 5.4273 18.7147 5.72991 18.744L5.86378 18.75H13.6365C14.2689 18.75 14.8054 18.325 14.9277 17.748L14.9488 17.622L16.2811 4.75H16.2822ZM11.5947 7.5C11.7858 7.50001 11.9703 7.56564 12.1143 7.68477C12.2583 7.80389 12.3519 7.96845 12.3779 8.148L12.3853 8.25V15.25C12.3852 15.44 12.3091 15.6229 12.1724 15.7618C12.0357 15.9006 11.8485 15.9851 11.6486 15.998C11.4488 16.011 11.2512 15.9515 11.0958 15.8316C10.9405 15.7117 10.8389 15.5402 10.8116 15.352L10.8042 15.25V8.25C10.8042 8.05109 10.8875 7.86032 11.0357 7.71967C11.184 7.57902 11.3851 7.5 11.5947 7.5ZM7.9055 7.5C8.09654 7.50001 8.28111 7.56564 8.42509 7.68477C8.56906 7.80389 8.66269 7.96845 8.68868 8.148L8.69605 8.25V15.25C8.69599 15.44 8.6199 15.6229 8.48316 15.7618C8.34642 15.9006 8.15922 15.9851 7.95939 15.998C7.75956 16.011 7.56199 15.9515 7.40661 15.8316C7.25124 15.7117 7.14963 15.5402 7.12233 15.352L7.11495 15.25V8.25C7.11495 8.05109 7.19824 7.86032 7.3465 7.71967C7.49476 7.57902 7.69584 7.5 7.9055 7.5ZM9.75012 1.5C9.28719 1.50002 8.84118 1.66517 8.50064 1.96268C8.1601 2.26019 7.94992 2.6683 7.91183 3.106L7.9055 3.25H11.5947C11.5947 2.78587 11.4004 2.34075 11.0545 2.01256C10.7085 1.68437 10.2393 1.5 9.75012 1.5Z"
                          fill="#FB4B4B"></path>
                    </svg>
                  </div>
                </td>
              </tr>
              <!-- <tr>
                <td>Invoice 34 could not be sent.</td>
                <td>
                  <p>Invoice 34 could not be sent because customer 56 is missing</p>
                  <p>an invoice email in Fortnox. Please add an email and trigger</p>
                  <p>a send out of the invoice.</p>
                </td>
                <td>2021-07-07</td>
                <td>2021-07-08</td>
                <td> <a href="alerts-full-message.html">See full message</a>
                  <div class="icons">
                    <svg width="22" height="21" viewbox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.7221 18.6663H4.27764V12.833H3.05542V18.6663C3.05542 18.9758 3.18419 19.2725 3.4134 19.4913C3.64261 19.7101 3.95349 19.833 4.27764 19.833H17.7221C18.0462 19.833 18.3571 19.7101 18.5863 19.4913C18.8155 19.2725 18.9443 18.9758 18.9443 18.6663V12.833H17.7221V18.6663Z" fill="black"></path>
                      <path d="M8.55542 14.0003C8.55542 14.155 8.6198 14.3034 8.73441 14.4128C8.84902 14.5222 9.00445 14.5837 9.16653 14.5837H12.8332C12.9953 14.5837 13.1507 14.5222 13.2653 14.4128C13.3799 14.3034 13.4443 14.155 13.4443 14.0003C13.4443 13.8456 13.3799 13.6972 13.2653 13.5878C13.1507 13.4784 12.9953 13.417 12.8332 13.417H9.16653C9.00445 13.417 8.84902 13.4784 8.73441 13.5878C8.6198 13.6972 8.55542 13.8456 8.55542 14.0003Z" fill="black"></path>
                      <path d="M9.1668 10.5H3.6668V8.16667H9.1668V7H3.36125C3.11813 7 2.88497 7.09219 2.71307 7.25628C2.54116 7.42038 2.44458 7.64294 2.44458 7.875V11.6667H9.64347C9.33926 11.3472 9.1695 10.9317 9.1668 10.5Z" fill="black"></path>
                      <path d="M18.6389 7H12.8334V8.16667H18.3334V10.5H12.8334C12.8307 10.9317 12.6609 11.3472 12.3567 11.6667H19.5556V7.875C19.5556 7.64294 19.459 7.42038 19.2871 7.25628C19.1152 7.09219 18.882 7 18.6389 7Z" fill="black"></path>
                      <path d="M7.94453 5.57059L10.389 3.26642V10.4998C10.389 10.6545 10.4534 10.8028 10.568 10.9122C10.6826 11.0216 10.838 11.0831 11.0001 11.0831C11.1622 11.0831 11.3176 11.0216 11.4322 10.9122C11.5468 10.8028 11.6112 10.6545 11.6112 10.4998V3.26642L14.0556 5.57059C14.1126 5.62459 14.1802 5.66736 14.2545 5.69644C14.3288 5.72552 14.4083 5.74035 14.4886 5.74008C14.5689 5.73981 14.6484 5.72444 14.7225 5.69486C14.7965 5.66528 14.8638 5.62206 14.9204 5.56767C14.9769 5.51328 15.0217 5.44879 15.0522 5.37787C15.0827 5.30695 15.0982 5.231 15.0979 5.15436C15.0976 5.07771 15.0815 5.00187 15.0506 4.93116C15.0196 4.86045 14.9743 4.79626 14.9173 4.74225L11.0001 1.03809L7.09509 4.74225C7.00045 4.85343 6.95198 4.99395 6.9589 5.13705C6.96583 5.28014 7.02768 5.4158 7.13265 5.51817C7.23763 5.62054 7.3784 5.68246 7.52813 5.69212C7.67785 5.70179 7.82607 5.65853 7.94453 5.57059Z" fill="black"></path>
                    </svg>
                    <svg width="20" height="21" viewbox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75012 6.97518e-09C10.6251 -5.43467e-05 11.467 0.317554 12.103 0.887672C12.7391 1.45779 13.121 2.23719 13.1706 3.066L13.1758 3.25H18.7097C18.91 3.25006 19.1028 3.32224 19.2492 3.45197C19.3955 3.5817 19.4845 3.7593 19.4982 3.94888C19.5118 4.13846 19.4491 4.32589 19.3227 4.4733C19.1963 4.62071 19.0156 4.7171 18.8172 4.743L18.7097 4.75H17.8707L16.5214 17.77C16.4538 18.4191 16.1453 19.0243 15.6508 19.4775C15.1563 19.9306 14.5081 20.2023 13.822 20.244L13.6365 20.25H5.86378C5.17596 20.25 4.51056 20.0179 3.98649 19.5953C3.46242 19.1727 3.11384 18.587 3.00304 17.943L2.97879 17.769L1.62853 4.75H0.79055C0.599514 4.74999 0.414942 4.68436 0.270968 4.56523C0.126995 4.44611 0.0333594 4.28155 0.00737844 4.102L0 4C8.05613e-06 3.81876 0.0691917 3.64366 0.194757 3.50707C0.320322 3.37048 0.493774 3.28165 0.683035 3.257L0.79055 3.25H6.3244C6.3244 2.38805 6.68533 1.5614 7.32777 0.951903C7.97022 0.34241 8.84156 6.97518e-09 9.75012 6.97518e-09ZM16.2822 4.75H3.21701L4.55252 17.622C4.58209 17.9092 4.7155 18.1779 4.93011 18.3824C5.14472 18.5869 5.4273 18.7147 5.72991 18.744L5.86378 18.75H13.6365C14.2689 18.75 14.8054 18.325 14.9277 17.748L14.9488 17.622L16.2811 4.75H16.2822ZM11.5947 7.5C11.7858 7.50001 11.9703 7.56564 12.1143 7.68477C12.2583 7.80389 12.3519 7.96845 12.3779 8.148L12.3853 8.25V15.25C12.3852 15.44 12.3091 15.6229 12.1724 15.7618C12.0357 15.9006 11.8485 15.9851 11.6486 15.998C11.4488 16.011 11.2512 15.9515 11.0958 15.8316C10.9405 15.7117 10.8389 15.5402 10.8116 15.352L10.8042 15.25V8.25C10.8042 8.05109 10.8875 7.86032 11.0357 7.71967C11.184 7.57902 11.3851 7.5 11.5947 7.5ZM7.9055 7.5C8.09654 7.50001 8.28111 7.56564 8.42509 7.68477C8.56906 7.80389 8.66269 7.96845 8.68868 8.148L8.69605 8.25V15.25C8.69599 15.44 8.6199 15.6229 8.48316 15.7618C8.34642 15.9006 8.15922 15.9851 7.95939 15.998C7.75956 16.011 7.56199 15.9515 7.40661 15.8316C7.25124 15.7117 7.14963 15.5402 7.12233 15.352L7.11495 15.25V8.25C7.11495 8.05109 7.19824 7.86032 7.3465 7.71967C7.49476 7.57902 7.69584 7.5 7.9055 7.5ZM9.75012 1.5C9.28719 1.50002 8.84118 1.66517 8.50064 1.96268C8.1601 2.26019 7.94992 2.6683 7.91183 3.106L7.9055 3.25H11.5947C11.5947 2.78587 11.4004 2.34075 11.0545 2.01256C10.7085 1.68437 10.2393 1.5 9.75012 1.5Z" fill="#FB4B4B"></path>
                    </svg>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Fortnox API is currently down.</td>
                <td>
                  <p>Fortnox API is experiencing some technical issues at the moment,</p>
                  <p>therefore you cannot utilize all features in this application until </p>
                  <p>that is resolved.</p>
                </td>
                <td>2021-07-01</td>
                <td>2021-07-05</td>
                <td><a href="alerts-full-message.html">See full message</a>
                  <div class="icons">
                    <svg width="22" height="21" viewbox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.7221 18.6663H4.27764V12.833H3.05542V18.6663C3.05542 18.9758 3.18419 19.2725 3.4134 19.4913C3.64261 19.7101 3.95349 19.833 4.27764 19.833H17.7221C18.0462 19.833 18.3571 19.7101 18.5863 19.4913C18.8155 19.2725 18.9443 18.9758 18.9443 18.6663V12.833H17.7221V18.6663Z" fill="black"></path>
                      <path d="M8.55542 14.0003C8.55542 14.155 8.6198 14.3034 8.73441 14.4128C8.84902 14.5222 9.00445 14.5837 9.16653 14.5837H12.8332C12.9953 14.5837 13.1507 14.5222 13.2653 14.4128C13.3799 14.3034 13.4443 14.155 13.4443 14.0003C13.4443 13.8456 13.3799 13.6972 13.2653 13.5878C13.1507 13.4784 12.9953 13.417 12.8332 13.417H9.16653C9.00445 13.417 8.84902 13.4784 8.73441 13.5878C8.6198 13.6972 8.55542 13.8456 8.55542 14.0003Z" fill="black"></path>
                      <path d="M9.1668 10.5H3.6668V8.16667H9.1668V7H3.36125C3.11813 7 2.88497 7.09219 2.71307 7.25628C2.54116 7.42038 2.44458 7.64294 2.44458 7.875V11.6667H9.64347C9.33926 11.3472 9.1695 10.9317 9.1668 10.5Z" fill="black"></path>
                      <path d="M18.6389 7H12.8334V8.16667H18.3334V10.5H12.8334C12.8307 10.9317 12.6609 11.3472 12.3567 11.6667H19.5556V7.875C19.5556 7.64294 19.459 7.42038 19.2871 7.25628C19.1152 7.09219 18.882 7 18.6389 7Z" fill="black"></path>
                      <path d="M7.94453 5.57059L10.389 3.26642V10.4998C10.389 10.6545 10.4534 10.8028 10.568 10.9122C10.6826 11.0216 10.838 11.0831 11.0001 11.0831C11.1622 11.0831 11.3176 11.0216 11.4322 10.9122C11.5468 10.8028 11.6112 10.6545 11.6112 10.4998V3.26642L14.0556 5.57059C14.1126 5.62459 14.1802 5.66736 14.2545 5.69644C14.3288 5.72552 14.4083 5.74035 14.4886 5.74008C14.5689 5.73981 14.6484 5.72444 14.7225 5.69486C14.7965 5.66528 14.8638 5.62206 14.9204 5.56767C14.9769 5.51328 15.0217 5.44879 15.0522 5.37787C15.0827 5.30695 15.0982 5.231 15.0979 5.15436C15.0976 5.07771 15.0815 5.00187 15.0506 4.93116C15.0196 4.86045 14.9743 4.79626 14.9173 4.74225L11.0001 1.03809L7.09509 4.74225C7.00045 4.85343 6.95198 4.99395 6.9589 5.13705C6.96583 5.28014 7.02768 5.4158 7.13265 5.51817C7.23763 5.62054 7.3784 5.68246 7.52813 5.69212C7.67785 5.70179 7.82607 5.65853 7.94453 5.57059Z" fill="black"></path>
                    </svg>
                    <svg width="20" height="21" viewbox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75012 6.97518e-09C10.6251 -5.43467e-05 11.467 0.317554 12.103 0.887672C12.7391 1.45779 13.121 2.23719 13.1706 3.066L13.1758 3.25H18.7097C18.91 3.25006 19.1028 3.32224 19.2492 3.45197C19.3955 3.5817 19.4845 3.7593 19.4982 3.94888C19.5118 4.13846 19.4491 4.32589 19.3227 4.4733C19.1963 4.62071 19.0156 4.7171 18.8172 4.743L18.7097 4.75H17.8707L16.5214 17.77C16.4538 18.4191 16.1453 19.0243 15.6508 19.4775C15.1563 19.9306 14.5081 20.2023 13.822 20.244L13.6365 20.25H5.86378C5.17596 20.25 4.51056 20.0179 3.98649 19.5953C3.46242 19.1727 3.11384 18.587 3.00304 17.943L2.97879 17.769L1.62853 4.75H0.79055C0.599514 4.74999 0.414942 4.68436 0.270968 4.56523C0.126995 4.44611 0.0333594 4.28155 0.00737844 4.102L0 4C8.05613e-06 3.81876 0.0691917 3.64366 0.194757 3.50707C0.320322 3.37048 0.493774 3.28165 0.683035 3.257L0.79055 3.25H6.3244C6.3244 2.38805 6.68533 1.5614 7.32777 0.951903C7.97022 0.34241 8.84156 6.97518e-09 9.75012 6.97518e-09ZM16.2822 4.75H3.21701L4.55252 17.622C4.58209 17.9092 4.7155 18.1779 4.93011 18.3824C5.14472 18.5869 5.4273 18.7147 5.72991 18.744L5.86378 18.75H13.6365C14.2689 18.75 14.8054 18.325 14.9277 17.748L14.9488 17.622L16.2811 4.75H16.2822ZM11.5947 7.5C11.7858 7.50001 11.9703 7.56564 12.1143 7.68477C12.2583 7.80389 12.3519 7.96845 12.3779 8.148L12.3853 8.25V15.25C12.3852 15.44 12.3091 15.6229 12.1724 15.7618C12.0357 15.9006 11.8485 15.9851 11.6486 15.998C11.4488 16.011 11.2512 15.9515 11.0958 15.8316C10.9405 15.7117 10.8389 15.5402 10.8116 15.352L10.8042 15.25V8.25C10.8042 8.05109 10.8875 7.86032 11.0357 7.71967C11.184 7.57902 11.3851 7.5 11.5947 7.5ZM7.9055 7.5C8.09654 7.50001 8.28111 7.56564 8.42509 7.68477C8.56906 7.80389 8.66269 7.96845 8.68868 8.148L8.69605 8.25V15.25C8.69599 15.44 8.6199 15.6229 8.48316 15.7618C8.34642 15.9006 8.15922 15.9851 7.95939 15.998C7.75956 16.011 7.56199 15.9515 7.40661 15.8316C7.25124 15.7117 7.14963 15.5402 7.12233 15.352L7.11495 15.25V8.25C7.11495 8.05109 7.19824 7.86032 7.3465 7.71967C7.49476 7.57902 7.69584 7.5 7.9055 7.5ZM9.75012 1.5C9.28719 1.50002 8.84118 1.66517 8.50064 1.96268C8.1601 2.26019 7.94992 2.6683 7.91183 3.106L7.9055 3.25H11.5947C11.5947 2.78587 11.4004 2.34075 11.0545 2.01256C10.7085 1.68437 10.2393 1.5 9.75012 1.5Z" fill="#FB4B4B"></path>
                    </svg>
                  </div>
                </td>
              </tr> -->
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="4">
                  <empty-component title="You currently do not have any archived notification..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalAlertVue v-if="showUnArchiveAlert" @handleClose="showUnArchiveAlert = false" :close="!true">
    <h4>{{ $t('archived_message') }} <span class="user-confirm text-danger">{{ $t('alert_message') }}</span>?</h4>
    <div class="popup-bottons">
      <button @click="showUnArchiveAlert = false">{{ $t('cancel_delete_request') }}</button>
      <button :disabled='processing' @click="UnArchiveAlertMessage">
        <span v-if="processing">{{ $t('unarchiving') }}...</span>
        <span v-else>{{ $t('accept_delete_request') }}</span>
      </button>
    </div>
  </ModalAlertVue>
  <ModalAlertVue v-if="showDeletedModalAlert" @handleClose="showDeletedModalAlert = false" :close="!true">
    <h4>{{ $t('delete_confirmation_text') }} <span class="user-confirm text-danger">{{ $t('archive_message') }}</span>?
    </h4>
    <div class="popup-bottons">
      <button @click="showDeletedModalAlert = false">{{ $t('cancel_delete_request') }}</button>
      <button :disabled='processing' @click="deleteAlertMessage">
        <span v-if="processing">{{ $t('deleting') }}...</span>
        <span v-else>{{ $t('accept_delete_request') }}</span>
      </button>
    </div>
  </ModalAlertVue>
</template>

<script>
import ModalAlertVue from '../../components/ModalAlert.vue'
import EmptyComponent from "./reusableComponents/EmptyComponent";

export default {
  components: {ModalAlertVue, EmptyComponent},
  data() {
    return {
      showUnArchiveAlert: false,
      showDeletedModalAlert: false,
      processing: false,
      archived: [],
      selectedAlert: null
    }
  },
  // computed : {
  //     ...mapGetters({
  //         ALERT : 'clients/GET_NOTIFY_ALERT'
  //     })
  // },
  mounted() {
    this.getArchiveMessage()
  },
  methods: {
    getArchiveMessage() {
      this.$store.dispatch('clients/getNotificationAlert', {archived: 'True'})
          .then(res => {
            this.archived = res.data.data
          })
          .catch(err => {
          })
    },
    UnArchiveAlertMessage() {
      this.processing = true
      const payload = {
        archived: false,
        id: this.selectedAlert.id
      }
      this.$store.dispatch('clients/archiveAlertMessage', payload)
          .then(res => {
            this.processing = false
            this.getArchiveMessage()
            this.showUnArchiveAlert = false
            // this.$services.helpers.notification('Successful unarchived alert message', 'success', this)
            this.$toast.success(this.$t('unarchived_alert'));
          })
          .catch(err => {
            this.processing = false
            this.$services.helpers.notification(err.response.data.message, 'error', this)
          })
    },
    deleteAlertMessage() {
      this.processing = true
      const payload = {
        id: this.selectedAlert.id
      }
      this.$store.dispatch('clients/deleteAlertMessage', payload)
          .then(res => {
            this.processing = false
            this.getArchiveMessage()
            this.showUnArchiveAlert = true
            // this.$services.helpers.notification('Alert message deleted successfully', 'success', this)
            this.$toast.success(this.$t('deleted_alert'));
          })
          .catch(err => {
            this.processing = false
            this.$services.helpers.notification(err.response.data.message, 'error', this)
          })
    },
    openDeletedMessageModal(data) {
      this.selectedAlert = data
      this.showDeletedModalAlert = true
    },
    openAlertMessage(data) {
      this.selectedAlert = data
      this.showUnArchiveAlert = true
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content h1 {
  margin: 20px 0;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content h1 ~ span {
  font-size: 18px;
  line-height: 28px;
  color: #27364b;
}

.content div ~ a {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #5855d6;
  text-decoration: none;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content div ~ a svg {
  margin-top: -2px;
}

.content div ~ a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content div ~ a:hover {
  color: #4946ae;
}

.content div ~ a:hover svg path {
  fill: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 5px;
  padding: 20px 40px 60px;
  margin-top: 20px;
  min-width: 1000px;
}

.content table {
  width: -webkit-calc(100% - 30px);
  width: calc(100% - 30px);
}

.content table tr {
  border-bottom: 1px solid rgba(151, 151, 151, 0.72);
  position: relative;
}

.content table thead th {
  padding: 0 10px 10px;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #333269;
}

.content table tbody td {
  padding: 20px 0 20px 10px;
}

.content table tbody td:not(:first-of-type) {
  vertical-align: baseline;
}

.content table tbody td:first-of-type {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
}

.content table tbody td p {
  font-size: 12px;
  line-height: 18px;
  margin: 0;
  color: #000000;
}

.content table tbody td:nth-child(3), .content table tbody td:nth-child(4) {
  font-size: 12px;
  line-height: 18px;
  color: #000000;
}

.content table tbody td a {
  text-decoration: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #5855d6;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content table tbody td a:hover {
  color: #4946ae;
}

.content table tbody td .icons {
  position: absolute;
  right: -30px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.content table tbody td .icons svg {
  cursor: pointer;
}

.content table tbody td .icons svg:first-of-type {
  margin-bottom: 10px;
}
</style>